import { FunctionComponent } from 'react'
import styles from './Loading.module.scss'
import { Role } from '@/types/Role'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/modules/context/AuthContext'

interface LoadingProps {
    overall?: boolean
    className?: string
    size?: 'small' | 'large' | 'medium'
}

const Loading: FunctionComponent<LoadingProps> = ({ overall = false, className, size = 'medium' }: LoadingProps) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    return (
        <div className={`${styles.Loader} ${overall ? styles.OverAllLoader : ''} ${className}`}>
            <span
                className={`
            ${styles.Load} 
            ${user?.role !== Role.parent ? styles.Daycare : styles.Parent}
            ${size === 'small' ? styles.Small : ''}
            ${size === 'large' ? styles.Large : ''}
            ${size === 'medium' ? styles.Medium : ''}
            `}
            ></span>
            <p className={`${styles.Text} ${user?.role !== Role.parent ? styles.Daycare : styles.Parent}`}>
                {t('loading')}
            </p>
        </div>
    )
}

export default Loading
